export default __webpack_public_path__ + "static/media/plus-circle.9f5b2b1b.svg";